// extracted by mini-css-extract-plugin
export var title = "MarkdownPostSeries-module--title--27c73";